import Footer from 'Common/components/Footer';

type BrowseServiceProvidersPageLayoutProps = {
  navigation?: React.ReactNode;
  children?: React.ReactNode;
}

const BrowseServiceProvidersPageLayout: React.FC<
  BrowseServiceProvidersPageLayoutProps
> = ({
  navigation,
  children,
}) => {

  return (
    <>
      {navigation}
      <div
        className="flex flex-col flex-grow bg-[#fcfaf9] items-center"
      >
        <div
          className="sm:w-full lg:w-4/5 sm:py-4 lg:py-8 sm:px-4 lg:px-0"
        >
          {children}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default BrowseServiceProvidersPageLayout;
